<template>
  <div>
    <div class="row">
      <div class="col">
        <card class="card" >
          <div class="row">
            <div class="col">
                <div>
                    <b-button @click="modalShow = !modalShow" class="float-left"><i class="tim-icons icon-zoom-split"></i>Cerca azienda</b-button>
                    <b-modal v-model="modalShow"  size="lg">
                    <template #modal-header="{ close }">
                        <!-- Emulate built in modal header close button action -->
                        <b-button size="sm" variant="outline-danger" @click="close()"> X</b-button>
                        <h3 style="color:black">Inserisci pratica</h3>
                    </template>
                    <template>
                        <div class="card-text">
                            <label for="cerca_azienda"><strong>NOME AZIENDA </strong></label>
                            <input class="form-control" type="text" placeholder="Nome azienda" name="cerca_azienda" v-model="cerca_zienda" v-on:change="cercaInfo()">
                            <label for="cerca_codice_fiscale"><strong>CODICE FISCALE </strong></label>
                            <input class="form-control" type="text" placeholder="Codice fiscale" name="cerca_codice_fiscale" v-model="cerca_codice_fiscale" v-on:change="cercaInfo()">
                            <label for="cerca_p_iva"><strong>PARTITA IVA</strong></label>
                            <input class="form-control" type="text" placeholder="Partita iva" name="cerca_p_iva" v-model="cerca_p_iva" v-on:change="cercaInfo()">
                            <hr>
                        </div>
                    </template>
                    
                    <template>
                        <div v-show="showRisultati">
                            <div v-if="cerca_info.length>0">
                                <table class="table tablesorter" style="text-align: center;">
                                <thead>
                                    <tr>
                                    <th>AZIENDA</th>
                                    <th>CF</th>
                                    <th>P. IVA</th>
                                    <th>SEDE</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(valori,index) in cerca_info" v-bind:key="valori.ID">
                                    <td style="text-decoration:underline"><a v-on:click="compilaForm(index)">{{valori.name}}</a></td>
                                    <td>{{valori.crm_cf_c}}</td>
                                    <td>{{valori.crm_piva_c}}</td>
                                    <td>{{valori.billing_address_street}}, {{valori.billing_address_city}} ({{valori.billing_address_state}}) {{valori.billing_address_postalcode}}</td><!--infoAzienda.billing_address_street + ", " + infoAzienda.billing_address_city + " (" + infoAzienda.billing_address_state + ") " +infoAzienda.billing_address_postalcode -->
                                    </tr>
                                </tbody>
                                </table>
                            </div>
                            <div v-else>
                            <div class="text-center" v-if="!nessunRisulato">
                                <circle-10></circle-10>
                                </div>
                                <div v-else>
                                <p>Nessun risultato trovato</p>
                                </div>
                                <!--<p>Nessun risultato trovato</p>-->
                            </div>
                            </div>
                        <!--<b-button size="sm" variant="danger" @click="cancel()">Cancel</b-button>
                        <b-button size="sm" variant="outline-danger" @click="ok()">OK</b-button>-->
                    </template>
                    </b-modal>
                </div>
            </div>
          </div>
          <form>
            <label for="azienda"><strong>AZIENDA </strong></label>
            <input class="form-control" type="text" placeholder="Nome azienda" name="azienda" v-model="azienda">

            <label for="codice_fiscale"><strong>CODICE FISCALE </strong></label>
            <input class="form-control" type="text" placeholder="Codice fiscale" name="codice_fiscale" v-model="codice_fiscale"><!-- v-on:keyup="getCF()" -->

            <label for="referente"><strong>REFERENTE AZIENDA </strong></label>
            <input class="form-control" type="text" placeholder="Referente azienda" name="referente" v-model="referente_azienda">

            <label for="tel"><strong>TEL </strong></label>
            <input class="form-control" type="text" placeholder="Telefono" name="tel" v-model="tel">

            <label for="mail"><strong>MAIL </strong></label>
            <input class="form-control" type="text" placeholder="Mail" name="mail" v-model="mail">

            <label for="sede"><strong>SEDE DOVE EFFETTUARE IL SOPRALLUOGO</strong></label>
            <input class="form-control" type="text" placeholder="Sede" name="sede" v-model="sede_sopraluogo">

            <label for="tipo_richiesta"><strong>TIPO RICHIESTA</strong></label>
            <input class="form-control" type="text" placeholder="Tipo richiesta" name="tipo_richiesta" v-model="tipo_richiesta">
          </form> 
        <button class="btn float-right" type="button" v-on:click="salvaValori" style="margin-bottom: 10px;background:#00467f">Salva</button>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import Card from '../components/Cards/Card.vue';
import {Modal} from '../components'
import {Circle10} from 'vue-loading-spinner'
  export default {
    name: 'aggiungi-dati',
    components: {
      Card,
      Modal,
      Circle10,
    },
    data() {
      return {
        modals: {
          mini: false
        },
        modalShow: false,
        showRisultati: false,
        nessunRisulato: false,
        cerca_zienda: '',
        cerca_codice_fiscale: '',
        cerca_p_iva: '',
        cerca_info: [],
        //ASCOM 1
        data_inserimento: null,
        azienda: null,
        codice_fiscale: null,
        referente_azienda: null,
        tel: null,
        mail: null,
        sede_sopraluogo: null,
        tipo_richiesta: null,
        
        id: null,
        valori: [],
        response: [],
        token_response:[],
        cf_response: [],
        urlRichieste: 'https://sviluppoallergeni.confcom.it/',//'https://apiintranet.confcom.it/'
      }
    },

    computed: {
    },

    methods: {
      cercaInfo: async function() {
        var errore = 0;
        const token = localStorage.getItem('access_token');
        await axios.get(
          this.urlRichieste + 'azienda?filter=true&name='+this.cerca_zienda+'&CF='+this.cerca_codice_fiscale+'&piva='+this.cerca_p_iva,
          //'https://sviluppoallergeni.confcom.it/azienda?filter=true&name='+this.cerca_zienda+'&CF='+this.cerca_codice_fiscale+'&piva='+this.cerca_p_iva, 
          {headers: {
              'Content-type': 'application/json',
              'Authorization': `Bearer ${token}`
          }}).then(response => { this.cerca_info = response.data})
          .catch( function (error) {
            // handle error
            //console.log("errore : ")
            //console.log(error);
            //console.log("error.status " + error.response.status)
            if(error.response.status == 401){
              errore = error.response.status
              //console.log("bisogna fare refresh token")
              //this.refreshToken()
            }
          })
        if (errore == 401) {
          await this.refreshToken()
          await this.cercaInfo()
          //console.log("rifatto richiesta a  pratiche dopo /token")
        }
        //console.log("cerca_info")
        //console.log(this.cerca_info)
        this.showRisultati = true
        if (this.cerca_info.length == 0) {
          this.nessunRisulato = true
        }
      },

      compilaForm: function(index){
        var infoAzienda = this.cerca_info[index]
        this.azienda = infoAzienda.name
        this.codice_fiscale = infoAzienda.crm_cf_c
        this.sede_sopraluogo =infoAzienda.billing_address_street + ", " + infoAzienda.billing_address_city + " (" + infoAzienda.billing_address_state + ") " +infoAzienda.billing_address_postalcode
        
      },
      
      salvaValori: async function() {
        var dati = [];
        var errore = 0;
        dati.push({ AZIENDA: this.azienda, CF: this.codice_fiscale, REFERENTE_AZIENDA:this.referente_azienda, TEL:this.tel, MAIL:this.mail, SEDE:this.sede_sopraluogo, TIPO:this.tipo_richiesta})
        var datiJSON=JSON.stringify(dati[0])
        const token = localStorage.getItem('access_token')

        axios.post(
          this.urlRichieste + 'pratica',
         // 'https://sviluppoallergeni.confcom.it/pratica', 
          datiJSON,
          {headers: {
              'Content-type': 'application/json',
              'Authorization': `Bearer ${token}`
        }}).then(response => { this.response = response.data})
          .catch( function (error) {
          // handle error
          //console.log("errore : ")
          //console.log(error);
          //console.log("error.status " + error.response.status)
          if(error.response.status == 401){
            errore = error.response.status
            //console.log("bisogna fare refresh token")
            //this.refreshToken()
            //this.salvaValori()
          }
        })
        if (errore == 401) {
          await this.refreshToken()
          await this.salvaValori()
          //console.log("rifatto richiesta a  pratiche dopo /token")
        }
        //console.log(this.response)
        this.$router.push({
        path: '/dashboard'
        })
      },

      refreshToken: async function(){
        await axios.post(
          this.urlRichieste + 'token',
          //"https://sviluppoallergeni.confcom.it/token",
          {
            withCredentials: true,
            headers: {
              'Content-type': 'application/json',
            }
          }
        ).then(response => { this.token_response = response.data})
        .catch(function (error) {
          // handle error
          //console.log("errore : ")
          //console.log(error);
          //console.log("error.status " + error.response.status)
          if(error.response.status == 403){
            console.log("token non valido")
            this.logout()
          }
        })
        //console.log("token_rspose = " + this.token_response.accessToken);
        localStorage.setItem('access_token', this.token_response.accessToken)
      },

      logout: async function () {
        //let ris = await logout.UserServices()
        let token = localStorage.getItem('access_token')
        await axios.delete(
          this.urlRichieste + 'logout',
          //'https://sviluppoallergeni.confcom.it/logout',
            {
            withCredentials: true,
            headers: {
              'Content-type': 'application/json',
              //'Authorization': `Bearer ${token}`
            }
          }
        ).then(response => { this.results = response.data})
        //console.log("stampo risposta /logout:")
        //console.log(this.results)
        localStorage.removeItem('access_token')
        localStorage.removeItem('refresh_token')
        localStorage.setItem('isLogged', false)
        localStorage.removeItem('user_nome')
        localStorage.removeItem('user_cognome')
        localStorage.removeItem('user_tipologia')
        localStorage.removeItem('user_email')
        localStorage.removeItem('user_livello')
        localStorage.removeItem('user_id')
        this.$router.push({
          path: '/login'
        })
        // window.location.reload()
      },

      main: function() {
        axios.defaults.withCredentials = true
      }
    },

    mounted() {
      this.main()
     
    }
    
  };
</script>
<style>
  body {
    font-family: Roboto,sans-serif;
  }
  button, input, optgroup, select, textarea {
      font-family: Roboto,sans-serif;
  }

</style>
